import createVueApp from '@phoenix/createVueApp';
import ModelGrid from '@maison/components/model/ModelGrid.vue';

Array.from(document.querySelectorAll('.phoenix-model-grid')).forEach((el) => {
  const app = createVueApp({}, true);
  app.component('ModelGrid', ModelGrid);
  app.mount(el);
});
